import { Analytics } from'../helpers/analytics';

export class ExpandFaq {
	constructor(elem) {
		this.elem = elem;
		this.question = this.elem.querySelector('.faq__question');
		this.answer = this.elem.querySelector('.faq__answer');

		this.setEventListeners();
	}

	setEventListeners() {
		this.question.addEventListener('click', () => {
			this.handleClick();
		});

		window.addEventListener('resize', () => {
			this.handleResize();
		})
	}

	handleClick() {
		this.elem.classList.toggle('active');
		this.setAnswerHeight();
		this.handleAnalytics(this.elem.classList.contains('active') ? 'open' : 'collapse');
	}

	handleResize() {
		this.setAnswerHeight();
	}

	setAnswerHeight() {
		if (this.elem.classList.contains('active')) {
			const answerHeight = this.answer.querySelector('article').clientHeight;
			this.answer.style.maxHeight = answerHeight + 'px';
		} else {
			this.answer.style.maxHeight = 0;
		}
	}

	handleAnalytics(state) {
		const category = this.elem.getAttribute(Analytics.analyticsTags.component) || 'faq_component';
		const label = this.elem.getAttribute(Analytics.analyticsTags.label);
		const data = {
			category: category,
			action: 'click - interact - ' + state,
			label: label
		};
		Analytics.measure(data);
	}

	static getSelector() {
		return '[data-faq-component]';
	}
}


